import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./officeDatatable";

import {
  getAllDocumentExpressRatesRedux,
  getAllOfficeRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";
import CreateDocumentModal from "./createDocumentModal";
import { connect } from "react-redux";
import "./office.css";

export class Office extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      office: null,
    };
  }

  componentDidMount = async () => {
    this.props.getAllOfficeRedux();
  };

  startToggleModal = async (officeObj) => {
    if (officeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, office: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        office: officeObj,
      });
    }
  };

  render() {
    const { open } = this.state;

    console.log(this.props);
    return (
      <Fragment>
        <CreateDocumentModal
          toggleModal={this.state.toggleModal}
          startToggleModal={this.startToggleModal}
          office={this.state.office}
        />
        <Breadcrumb title="Office" parent="Cash in/out" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid of-page kd-cash kd-st--lilac">
          <div className="row">
            <div className="col-sm-12">
              <div className="card of-card">
                <div className="card-header of-card-header" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                  <h5 className="of-card-title">
                    <i className="icofont-building-alt of-card-icon"></i>
                    Offices
                  </h5>
                  <button
                    className="btn of-add-btn"
                    type="button"
                    onClick={() => this.startToggleModal(null)}
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i> Add office
                  </button>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      multiSelectOption={false}
                      myData={this.props.allOffices}
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allOffices: state.offices.offices,
  };
};

export default connect(mapStateToProps, {
  getAllDocumentExpressRatesRedux,
  getAllOfficeRedux,
})(Office);
